import React from "react";
import { DateSelectElement, DateAllElement, getMonday } from "./dateElement.jsx";
export default function WeekTableMobile(props) {
    var now = new Date();
    if(now.getHours() < 18){ //Only allow same day bookings before 6PM
        now.setDate(now.getDate() - 1);
    }
    return <tbody>
        <tr>
            <th colSpan="20">Week {props.weekNo} - {getMonday(props.dates[0]).format("jS F")}</th>
        </tr>
        {["Mon", "Tue", "Wed", "Thu", "Fri"].map((dLbl, idx) => <WeekTableMobileRow key={dLbl} idx={idx} now={now} label={dLbl} day={dLbl} {...props} />)}
        <tr>
            <th></th>
            {props.items.map(mainItem => {
                return [
                    <DateAllElement key={mainItem.id} {...props} now={now} type={mainItem.id} parent={props.parent} />
                    ,
                    mainItem.extras.map(subItem => <DateAllElement key={subItem.id} {...props} now={now} type={subItem.id} dates={props.dates} parent={mainItem.id} />)
                ]
            })}
        </tr>


    </tbody>
}

function WeekTableMobileRow(props) {
    return <tr>
        <th>{props.label}</th>
        {props.items.map(mainItem => {
            return [
                <DateSelectElement key={mainItem.id} {...props} type={mainItem.id} dates={props.dates} />,
                mainItem.extras.map(subItem => <DateSelectElement key={subItem.id} {...props} type={subItem.id} dates={props.dates} parent={mainItem.id} />)
            ]
        })}
    </tr>
}


// WEBPACK FOOTER //
// ./flexi/weektable/mobile.jsx